module.exports = __webpack_public_path__ + "static/main-img-dd0964aeac3ccf54093623c395984cf3.svg";